import { Outlet } from "react-router-dom";
import { TofuSidebar } from "@components/ui_v2/TofuSidebar";
import { NavbarTofuMobile } from "@components/ui_v2/NavbarTofuMobile";
import { OnboardingWizardLayout } from "@components/ui_v2/OnboardingWizardLayout";

/**
 * Variante del wizard para las pantallas que el diseño resuelve a todo lo ancho
 * (`.content-wide` con `max-width: 1200`), como el marketplace de preofertas: tres
 * tarjetas por fila no caben en la columna de 700px que usan los pasos de captura.
 *
 * Mismo sidebar y mismo fondo que `TofuLayout`; solo cambia el ancho de la columna.
 */
const TofuLayoutWide = () => (
  <OnboardingWizardLayout
    sidebar={<TofuSidebar />}
    mobileNavbar={<NavbarTofuMobile />}
    maxContentWidth={1200}
    contentWidth="100%"
  >
    <Outlet />
  </OnboardingWizardLayout>
);

export default TofuLayoutWide;
